import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Modal } from 'synfrastructure';

import { selectHasUserCompleted60Day, select60DayCourse } from '../redux/selectors';

class SixtyDayWarningModal extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
  };

  state = {
    modalDismissed: false,
  };

  handleDismissWarning = () => {
    this.setState({ modalDismissed: true });
  };

  renderModalContents = () => {
    const { sixtyDayCourse } = this.props;

    const sixtyDayLink = <Link to={`/subscription/courses/${sixtyDayCourse.id}`}>{sixtyDayCourse.name}</Link>;

    return (
      <div>
        <div className="modal__content">
          <h3>Already completed the 60-Day Program?</h3>
          <p>
            This course builds on top of the training and movements you learned throughout the {sixtyDayLink}. We
            recommend every member begin with the {sixtyDayLink} before proceeding to the additional courses.
          </p>
        </div>
        <div className="modal__actions">
          <button type="submit" className="button" onClick={this.handleDismissWarning}>
            Dismiss
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { course, sixtyDayCourse, hasPassed60Day } = this.props;
    const { modalDismissed } = this.state;

    if (!sixtyDayCourse) {
      return null;
    }
    return (
      <div className="sixty-day-warning__modal">
        <Modal
          isVisible={!modalDismissed && !hasPassed60Day && !course.enrolled && course.id !== sixtyDayCourse.id}
          onClose={this.handleDismissWarning}
        >
          {this.renderModalContents()}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    hasPassed60Day: selectHasUserCompleted60Day(state, props),
    sixtyDayCourse: select60DayCourse(state, props),
  };
};

export default withRouter(connect(mapStateToProps)(SixtyDayWarningModal));



// WEBPACK FOOTER //
// ./src/subscription/courses/components/SixtyDayWarningModal.js